import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ breakpoints }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [breakpoints.between(0, 321)]: {
      flexFlow: 'column',
    },
  },
}));
